import {
  type DocumentKind,
  type DocumentTemplatePreview,
  DocumentTemplatesService,
} from "@common/client"
import { keepPreviousData } from "@tanstack/react-query"
import {
  makeAxiosMutation,
  makeNoArgsQuery,
  makeQuery,
  parseBlobErrors,
} from "./utils"

export const documentTemplatesBaseKey = ["document-templates"] as const

export const documentTemplateKey = (kind: DocumentKind) =>
  [...documentTemplatesBaseKey, kind] as const

export const documentTemplatesQuery = makeNoArgsQuery({
  serviceCall: DocumentTemplatesService.listDocumentTemplates,
  queryKey: documentTemplatesBaseKey,
})

export const documentTemplateQuery = makeQuery({
  serviceCall: (kind: DocumentKind) =>
    DocumentTemplatesService.getDocumentTemplate({ kind }),
  queryKey: documentTemplateKey,
})

const previewDocumentTemplate = parseBlobErrors(
  (documentTemplatePreview: DocumentTemplatePreview) =>
    DocumentTemplatesService.previewDocumentTemplate({
      documentTemplatePreview,
    }),
)

export const documentTemplatePreviewQuery = makeQuery({
  serviceCall: previewDocumentTemplate,
  queryKey: (preview: DocumentTemplatePreview) => [
    ...documentTemplatesBaseKey,
    "preview",
    preview,
  ],
  placeholderData: keepPreviousData,
  gcTime: 0,
  retry: false,
})

export const useUpdateDocumentTemplateMutation = makeAxiosMutation({
  serviceCall: DocumentTemplatesService.updateDocumentTemplate,
  invalidates: () => [documentTemplatesBaseKey],
})

export const useResetDocumentTemplateMutation = makeAxiosMutation({
  serviceCall: DocumentTemplatesService.resetDocumentTemplate,
  invalidates: () => [documentTemplatesBaseKey],
})
